import React, { useState, useEffect } from 'react';
import { Typography, Button, DialogContent, DialogContentText, DialogActions, FormControl,TextField,InputLabel, Select as MSelect, MenuItem, Checkbox, ListItemText,
    Box } from '@mui/material';
import { getUserType, getUserTypeByDashboardId } from '../../../config/services/usertype';
import { validateUserRole } from '../../../config/services/role';

import {ReactComponent as AngleDownIcon } from '../../../assets/icons/icon-angle-down.svg';
import { getDashboarByUser } from '../../../config/services/publishDashboard';
import { DecryptData } from '../../../utils/encryptDecrypt';
import moment from 'moment';

export default function PublishDashboardPopup({ dashboardId, handleSubmitPublishDashboard, dashboardName }) {
    const [userTypeList, setUserTypeList] = useState([]);
    const [userTypeAccess, setUserTypeAccess] = useState([]);
    const [publishedDashboardList,setPublishedDashboardList] = useState([]);
    const [publishActionType,setPublishActionType] = useState("")
    const [selectedPublishedDashboard,setSelectedPublishedDashboard] = useState(null)
    const [publishDashName, setPublishDashName] = useState(dashboardName || '')
    let role = DecryptData(localStorage.getItem('role'))


    const fetchUserTypeList = async () => {
        const res = await validateUserRole({populateDeep: true});
        if (res) {
            const selectedUserList = res?.userType[0]?.userTypeList ? res?.userType[0]?.userTypeList : []
            setUserTypeList(selectedUserList)
      };
    }

    const getUserTypeId = (namelist) => {
        let userTypeListA = namelist?.map((obj) => {
            let searchObj = userTypeList.find(d => d['userTypeName'] === obj)
            if (searchObj?._id)
                return searchObj._id;
            else
                return null
        })
        let userTypeListIds = userTypeListA.filter((obj) => obj);
        return userTypeListIds;
    }
    
    useEffect(() => {
        fetchUserTypeList();
    }, []);

    const fetchPublishedDashboardList = () => {
      getDashboarByUser().then(res => {
        if(res?.result?.length)
               setPublishedDashboardList(res?.result)
      });   
    }

    const handlePublishAction = (e) => {
        const { value } = e?.target
        if(value === "replace") {
           fetchPublishedDashboardList()
        }
        setPublishActionType(value)
    }
    
    const getPublishedDashboardId = () => {
        if(publishedDashboardList?.length) {
            return publishedDashboardList.find(dashboard => dashboard?.dashboardName === selectedPublishedDashboard)?._id
        }
        else {
            return ""
        }
    }

    const setUserTypeAccessHandler = (e) => {
        let { value } = e.target;
        setUserTypeAccess([...value]);
    }

    return (
        <Box>
                <Typography variant="body2" className="modal-title text-plain" > Are you Sure you want to Publish Dashboard?</Typography>
                <Typography variant="body2" component="p" color="textSecondary" className='text-small label'>Publish Dashboard Name</Typography>
                <FormControl variant="outlined" className="report-form-label" sx={{ width: "100%" }}>
                    <TextField className="report_form_ui_input text-small" style={{width: '100%'}} value={publishDashName} onChange={e => setPublishDashName(e?.target?.value)}/>
                </FormControl>
                
                <Typography variant="body2" component="p" color="textSecondary" className='text-small label'>Share with</Typography>
                <FormControl variant="outlined" className="report-form-label" sx={{ width: "100%" }}>
                    <MSelect
                        className="report_form_ui_input_select pl-0 text-smal"
                        multiple
                        IconComponent={AngleDownIcon}
                        value={userTypeAccess}
                        renderValue={(selected) => selected.join(", ")}
                        onChange={(e) => setUserTypeAccessHandler(e)}
                        MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null
                        }}
                    >
                        {
                            userTypeList?.map((data) => (
                                <MenuItem className='menu-item-small' key={data?._id} value={data?.userTypeName}>
                                    <Checkbox className="form_checkbox" checked={userTypeAccess?.indexOf(data?.userTypeName) > -1} />
                                    <ListItemText className="text-small" primary={data?.userTypeName} />
                                </MenuItem>
                            ))
                        }
                    </MSelect>
                </FormControl>
                
                <Typography variant="body2" component="p" color="textSecondary" className='text-small label'>Action</Typography>
                <FormControl variant="outlined" className="report-form-label" sx={{ width: "100%" }}>
                    <MSelect
                        className="report_form_ui_input_select pl-0 text-smal"
                        IconComponent={AngleDownIcon}
                        value={publishActionType}
                        onChange={handlePublishAction}
                        MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null
                        }}
                    >
                                         
                            <MenuItem value="create">Create New</MenuItem>
                            <MenuItem value="replace">Replace Existing</MenuItem>                         
                    </MSelect>
                </FormControl>
                
              {  
                publishActionType === 'replace' &&
              <>
                <Typography variant="body2" component="p" color="textSecondary" className='text-small label'>Select Published Dashboard</Typography>
                <FormControl variant="outlined" className="report-form-label" sx={{ width: "100%" }}>
                    <MSelect
                        className="report_form_ui_input_select pl-0 text-smal"
                        IconComponent={AngleDownIcon}
                        value={selectedPublishedDashboard}
                        renderValue={(selected) => selected}
                        onChange={(e) => setSelectedPublishedDashboard(e?.target?.value)}
                        MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null
                        }}
                    >
                        {
                            publishedDashboardList?.map((data) => (
                                <MenuItem className='menu-item-small' key={data?._id} value={data?.dashboardName}>
                                    {
                                    <>    
                                    <p>{data?.dashboardName}</p> &nbsp;&nbsp;  
                                    { (role.toLowerCase() === 'superadmin') ?
                                    <p style={{color:'gray', fontStyle:'italic'}}> Created By: {(data?.createdByDetails?.s_uuid ?? data?.createdByDetails?.email) } </p> : null 
                                    }
                                            {
                                                data?.updatedAt
                                                    ? <p style={{ color: 'black', fontStyle: 'italic', marginLeft: '2px' }}>{`updated: ${moment(data?.updatedAt).fromNow()}`}</p>
                                                    : null
                                            }
                                    </>
                                    }
                                </MenuItem>
                            ))
                        }
                    </MSelect>
                </FormControl>
                </>
                }
                

            <Box sx={{mt: 4}} className="modal-footer text-right mb-0">
                <Button onClick={() => handleSubmitPublishDashboard({type:'cancel'})} className="report_form_ui_btn mr-2 cancel" color="error" variant="outlined"> Cancel </Button>
                <Button onClick={() => handleSubmitPublishDashboard({type: 'publish', userTypeAccessList: getUserTypeId(userTypeAccess), publishActionType,selectedPublishedDashboard: getPublishedDashboardId(), publishDashboardName: publishDashName})} color="primary"
                    className="report_form_ui_btn submit" autoFocus variant="contained"> Publish </Button>
            </Box>
        </Box>
    )
}